<div class="relative flex flex-col" [ngClass]="{ 'm-6 rounded-lg shadow-sm': padded }">
  <!-- To make tables responsive, we are hiding some columns on smaller screens. -->
  <!-- This message should appear whenever a column is hidden and is controlled from the listing template -->
  <div class="absolute right-2 -top-4 text-2xs font-normal italic leading-none text-gray-500 empty:hidden">
    <ng-content select="[slot='hidden-columns-message']"></ng-content>
  </div>

  <div class="grid grid-cols-1 items-start justify-between gap-8 rounded-t-lg bg-white p-4">
    <div class="text-xl font-medium empty:hidden">
      <ng-content select="[slot='title']"></ng-content>
    </div>

    <div class="flex items-start justify-between">
      <div class="mr-4 grid auto-cols-auto grid-flow-col items-center gap-4">
        <div class="filters-wrapper flex flex-wrap gap-4 empty:hidden">
          <ng-content select="[slot='filters']"></ng-content>
        </div>

        <div class="flex h-11 items-center self-start text-xs uppercase text-gray-500 empty:hidden">
          <ng-content select="[slot='total']"></ng-content>
        </div>
      </div>

      <div class="actions-wrapper empty:hidden">
        <ng-content select="[slot='actions']"></ng-content>
      </div>
    </div>
  </div>

  <ng-content select="[slot='table']"></ng-content>
  <div class="overflow-hidden rounded-b-lg empty:hidden">
    <ng-content select="[slot='pagination']"></ng-content>
  </div>
</div>
